import { ClientOnly } from '~/common/nextJsUtils'
import { Optional } from '~/common/types'
import { FilterTabs, FilterTabsProps } from '~/design_system'
import { track } from '~/third_party/analytics'
import { useActionBarContext } from './ActionBar.hook'

type ActionBarFilterTabsProps = Optional<FilterTabsProps, 'value' | 'onChange'>

export const ActionBarFilterTabs = ({
  value: valueProp,
  onChange: onChangeProp,
  ...props
}: ActionBarFilterTabsProps) => {
  const { filterTab: filterTabContext } = useActionBarContext()

  const value = valueProp ?? filterTabContext?.value ?? undefined

  function onChange(nextValue: string) {
    track('Tasks List Filter Tab', { tab_value: nextValue })
    onChangeProp?.(nextValue)
    filterTabContext?.onChange?.(nextValue)
  }

  return (
    // Wrap with ClientOnly to prevent SSR issues since FilterTabs initial value is pulled from the query string
    // which is only available on the client side.
    <ClientOnly>
      <FilterTabs
        value={value}
        onChange={onChange}
        data-action-bar-filter-tabs
        data-testid="action-bar-filter-tab"
        display="flex"
        justifyContent="center"
        alignItems="center"
        {...props}
      />
    </ClientOnly>
  )
}
